import serverVars from 'server-vars';
import { getCurrency } from 'dibs-intl/exports/units';
import { graphql, readInlineData } from 'react-relay/legacy';

import { localStorage, sessionStorage } from 'dibs-browser-storage';
import { getParamFromUrl } from './checkoutRedirects';

export function getOfferCurrency(buyerCurrency) {
    return (
        getParamFromUrl('offerCurrency') ||
        buyerCurrency ||
        localStorage.getItem('userCurrency') ||
        sessionStorage.getItem('userCurrency') ||
        getCurrency(serverVars.get('locale'))
    );
}

export function getSkuId() {
    return getParamFromUrl('skuId');
}

const buyerFragment = graphql`
    fragment checkoutHelpers_buyer on User @inline {
        addressBook {
            addressList {
                serviceId
                state
                displayState
            }
        }
    }
`;

export function getShippingAddressById({ buyer, shippingAddressId }) {
    const buyerData = readInlineData(buyerFragment, buyer);
    return (buyerData?.addressBook?.addressList || []).find(
        address => address?.serviceId === shippingAddressId
    );
}
